import { render, staticRenderFns } from "./BestMovies.vue?vue&type=template&id=451df9a6&scoped=true&"
import script from "./BestMovies.vue?vue&type=script&lang=js&"
export * from "./BestMovies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451df9a6",
  null
  
)

export default component.exports